export default __webpack_public_path__ + "static/bg-7ee08f42c61ed279e8c523485d69d54d.png";